<template>
  <v-card
    class="mx-auto"
  >
    <v-card-text v-if="!loading">

        <v-row class="mx-4">
          <v-text-field
            style="max-width: 200px;"
            outline 
            v-model="campForAction"
            label="Όνομα Περιοχής"
          ></v-text-field>

          <v-btn @click="createCamp" primary class="mx-2 ml-4 mt-2" color="green">
            ΔΗΜΙΟΥΡΓΙΑ
          </v-btn>

          <v-dialog
            v-model="campClearDialog"
            width="500"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="orange"
                dark
                v-bind="attrs"
                v-on="on"
                class="mx-2 mt-2"
              >
                Εκκαθ. Συμβάντων
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                Επιβεβαίωση
              </v-card-title>

              <v-card-text>
                Η εκκαθάριση όλων των συμβάντων για μία περιοχή ενδιαφέροντος είναι μη-αναστρέψιμη.
                Γράψτε {{ campForAction }} για να επιβεβαιώσετε την εκκαθάριση:

                  <v-text-field
                    style="max-width: 200px;"
                    outline 
                    v-model="campForActionClearConfirm"
                    :label="campForAction"
                  ></v-text-field>
              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="orange"
                  @click="clearCamp"
                  :disabled="campForAction !== campForActionClearConfirm"
                >
                  Ναι, εκκαθάριση
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog
            v-model="campDeleteDialog"
            width="500"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="red"
                dark
                v-bind="attrs"
                v-on="on"
                class="mx-2 mt-2"
              >
                ΔΙΑΓΡΑΦΗ
              </v-btn>
            </template>

            <v-card>
              <v-card-title>
                Επιβεβαίωση
              </v-card-title>

              <v-card-text>
                Διαγραφή μιας περιοχής ενδιαφέροντος μπορεί να προκαλέσει προβλήματα με ήδη υπάρχοντες χρήστες, αισθητήρες και συμβάντα.
                Γράψτε {{ campForAction }} για να επιβεβαιώσετε τη διαγραφή:

                  <v-text-field
                    style="max-width: 200px;"
                    outline 
                    v-model="campForActionDeleteConfirm"
                    :label="campForAction"
                  ></v-text-field>
              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red"
                  @click="deleteCamp"
                  :disabled="campForAction !== campForActionDeleteConfirm"
                >
                  Ναι, ΔΙΑΓΡΑΦΗ
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>

      <v-data-table dense v-if="!loading"
        :headers="tableHeader"
        :items="tableCamps"
        item-key="camp"
        :options.sync="pagination"
        :search="search"
        :custom-filter="filter"
        @click:row="handleRowClick"
      >
        <template v-slot:top>
        <v-text-field
          style="max-width: 400px;"
          outline 
          max=30
          v-model="search"
          label="Αναζήτηση"
          class="mx-4"
        ></v-text-field>
      </template>

      </v-data-table>

    </v-card-text>

  </v-card>
</template>

<script>

export default {
  name: 'CampManagement',
  async mounted() {
    await this.load()
  },
  data: () => {
    return {
      search: '',
      loading: false,
      error: "",
      camps: [],
      campForAction: "",
      campForActionDeleteConfirm: "",
      campForActionClearConfirm: "",
      campDeleteDialog: false,
      campClearDialog: false,
      pagination: {
        itemsPerPage: 100
      },
      tableHeader: [
        {
          text: 'camp',
          align: 'start',
          sortable: true,
          value: 'camp'
        }
      ]
    }
  },
  computed: {
    tableCamps() {
      return this.camps.map(function(x) {
        return {
          camp: x
        }
      })
    }
  },
  methods: {
    handleRowClick(row) {
      this.campForAction = row.camp
    },
    async createCamp() {
      try{
        const response = await this.$axios.post(`/camps/${this.campForAction}`)
        this.camps = response.data
        this.campForAction = ""
        this.campForActionDeleteConfirm = ""
      } catch (e) {
        console.log(e.response)
        this.error = e.response.data 
      }
      await this.load()
    },
    async deleteCamp(){
      try{
        const response = await this.$axios.delete(`/camps/${this.campForAction}`)
        this.camps = response.data
        this.campForAction = ""
        this.campForActionDeleteConfirm = ""
      } catch (e) {
        console.log(e.response)
        this.error = e.response.data 
      }

      this.campDeleteDialog = false
      await this.load()
    },
    async clearCamp() {
      try{
        const query = { camp: this.campForActionClearConfirm}
        const response = await this.$axios.delete('/sensorEvents/clearCamp', { params:{...query}})
        console.log(`Clearing events for camp: ${this.campForActionClearConfirm}`)
        console.log(response)
        this.campForAction = ""
        this.campForActionClearConfirm = ""
      } catch (e) {
        console.log(e.response)
        this.error = e.response.data
      }
      this.campClearDialog = false
    },
    async load() {
      this.loading = true
      try{
        const response = await this.$axios.get('/camps')
        this.camps = response.data
      } catch (e) {
        console.log(e.response)
        this.error = e.response.data
      }

      this.loading = false
    },
    /* eslint-disable */
    filter (value, search, _item) {  // _item unused var
    /* eslint-enable */
      return value != null &&
        search != null &&
        typeof value === 'string' &&
        value.toString().toLowerCase().indexOf(search) !== -1
    },
  }
}
</script>
